import {actionNames} from 'constants/index';
const mapDispatchToProps = dispatch => ({
    SOLICITUD_EMPADRONAMIENTO_EXTRANJERO_SET_STEP: (step)=> 
        dispatch({ "type":actionNames.SOLICITUD_EMPADRONAMIENTO_EXTRANJERO_SET_STEP, payload : step}),
        
    SOLICITUD_EMPADRONAMIENTO_SET_ES_RECHAZADO_O_EMPADRONADO: (esRechazadoOEmpadronado)=> 
        dispatch({ "type":actionNames.SOLICITUD_EMPADRONAMIENTO_SET_ES_RECHAZADO_O_EMPADRONADO,"state":{"esRechazadoOEmpadronado":esRechazadoOEmpadronado}}),            
    SOLICITUD_EMPADRONAMIENTO_SET_DATOS_RESIDENCIA: (datosResidencia)=> 
        dispatch({ "type":actionNames.SOLICITUD_EMPADRONAMIENTO_SET_DATOS_RESIDENCIA,"state":{"datosResidencia":datosResidencia}}),          
    SOLICITUD_EMPADRONAMIENTO_SET_ARRAY_LISTADO: (ArrayListado)=> 
        dispatch({ "type":actionNames.SOLICITUD_EMPADRONAMIENTO_SET_ARRAY_LISTADO,"state":{"ArrayListado":ArrayListado}}),          
});  
export default mapDispatchToProps;